var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8239C1.86997 9.63588 4.39977 6.88388 7.41973 4.7522C10.4397 2.62061 13.8798 1.15826 17.5093 0.463186C21.1397 -0.231889 24.8768 -0.14381 28.4697 0.721607C32.0637 1.58712 35.4308 3.20985 38.3472 5.4815C41.2626 7.75315 43.6603 10.6212 45.3784 13.894C47.0965 17.1667 48.0966 20.7687 48.3106 24.4589C48.5246 28.1491 47.9486 31.8427 46.6211 35.2923C45.2926 38.7421 43.2441 41.8684 40.6107 44.4624L31.1622 34.8695C32.4296 33.6207 33.4169 32.1156 34.056 30.4549C34.6951 28.7942 34.9722 27.0162 34.8696 25.2396C34.7661 23.4631 34.2847 21.7291 33.4573 20.1536C32.6308 18.5781 31.4759 17.1974 30.0724 16.1037C28.669 15.0102 27.0475 14.229 25.3176 13.8124C23.5877 13.3957 21.7887 13.3533 20.041 13.6879C18.2934 14.0225 16.6374 14.7265 15.1837 15.7527C13.7299 16.7789 12.5128 18.1037 11.6123 19.6385L0 12.8239Z",
    fill: "#FF9D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.39fa6741fef20f1849ed695f3bf37cc1.svg";
export { ForwardRef as ReactComponent };